import React from 'react';
import dateformat from 'dateformat';

const RefreshButton = (props, context) => {
  const currentTime = new Date();
  const currentFormatted = dateformat(new Date(currentTime), 'HH:MM');
  const refreshPage = () => context.refresh();

  return (
    <div className="mt-control-item mt-refresh-button-wrapper text--blue-dark" onClick={refreshPage}>
      <div className="mt-refresh-button-wrapper-icon icon-icon_update icon--large cursor--pointer text--blue-dark"></div>
      <div className="mt-refresh-button-wrapper-time text--blue-dark">{currentFormatted}</div>
    </div>
  );
};

RefreshButton.contextTypes = {
  refresh: React.PropTypes.func,
};

export default RefreshButton;



/** WEBPACK FOOTER **
 ** ./core_components/TimingHandler/TimeNavigation/controls/RefreshButton.js
 **/